import React from 'react'

import {EntitySelectorEntityType} from "../@const"
import EntitySelectorUsers from "./user/user"
import EntitySelectorTasks from "./task/task"
import EntitySelectorDocuments from "./document/document"
import EntitySelectorProjects from "./project/project"
import EntitySelectorMeetings from "./meeting/meeting"

type Props = {
    currentEntityType   : EntitySelectorEntityType
}

// const debug = "EntitySelectorMain"
const debug = false

// Which tab is showing, and nothing else: what a tab is scoped to and where its
// pick goes come off the context (`../context.tsx`), so this no longer forwards
// a set of props it has no use for.
export default function EntitySelectorMain (props:Props) {

    debug && console.log(debug, 'render', props.currentEntityType)

    switch (props.currentEntityType) {
        case EntitySelectorEntityType.USER      :
            return <EntitySelectorUsers/>

        case EntitySelectorEntityType.TASK      :
            return <EntitySelectorTasks/>

        case EntitySelectorEntityType.DOCUMENT  :
            return <EntitySelectorDocuments/>

        case EntitySelectorEntityType.PROJECT   :
            return <EntitySelectorProjects/>

        case EntitySelectorEntityType.MEETING   :
            return <EntitySelectorMeetings/>

        default:
            return null
    }
}
